// extracted by mini-css-extract-plugin
export default {"modal":"UpsertTimeSlotModal_modal__HzNRm","form":"UpsertTimeSlotModal_form__IvoOc","checkboxRow":"UpsertTimeSlotModal_checkboxRow__hXfvI"};